"use client";

import React, { useEffect, useRef, useState } from "react";
import dynamic from "next/dynamic";
import { X } from "lucide-react";
import { createPortal } from "react-dom";
import Header from "@/components/Header";
import HeroBannerVideo from "../HomePage/HeroBanner";
import HomeOffersTabs from "@/components/HomeOffersTabs";
import FilterBar from "@/app/cin_booking_engine/Filterbar";
import { BookingEngineProvider } from "@/app/cin_context/BookingEngineContext";
import { useRouter } from "next/navigation";
import ExploreSkeleton from "@/components/SkeletonComponent/ExploreSectionSkeleton";

export default function OrangeTigerOffersClient({ contentData, tokenKey }) {
  const router = useRouter();
  const filterBarRef = useRef(null);
  const [isOpen, setOpen] = useState(false);
  const [showFilterBar, setShowFilterBar] = useState(false);
  const [isOpenFilterBar, openFilterBar] = useState(false);
  const [staahPropertyId, setStaahPropertyId] = useState(null);
  const [cityDetails, setCityDetails] = useState(null);
  const [isHandleSearchProp, setHandleSearchProp] = useState(false);
  const [activeTab, setActiveTab] = useState("offers");
  const [staahOfferId, setStaahOfferId] = useState(0);

  // useEffect(() => {
  //   if (typeof window !== "undefined") {
  //     setShowFilterBar(window.innerWidth >= 768);
  //     setIsMobile(window.innerWidth < 768);
  //   }
  // }, []);

  useEffect(() => {
    if (tokenKey) {
      openFilterBar((prev) => !prev);
    }
  }, [tokenKey]);

  const handlePropertyBookNow = async (property = null) => {
    // if (window.innerWidth < 768) {
    setOpen((prev) => !prev);
    setShowFilterBar((prev) => !prev);
    // }

    const label = property?.cityName;
    const value = property?.cityId;
    const property_Id = property?.staahPropertyId;
    const staahRoomsId = property?.staahRoomsId;
    setCityDetails({ label, value, property_Id, staahRoomsId });
    setStaahPropertyId(property?.staahPropertyId);
    // setHandleSearchProp(true);

    if (filterBarRef.current) {
      filterBarRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      const firstInput = filterBarRef.current.querySelector(
        "input, select, button",
      );
      if (firstInput) firstInput.focus();
    }
  };

  const handleOfferPackage = async (newProperty = null) => {
    // if (window.innerWidth < 768) {
    setOpen((prev) => !prev);
    setShowFilterBar((prev) => !prev);
    // }

    let prperty = {};
    if (parseInt(newProperty?.propertyOfferId) > 0 && newProperty?.property) {
      setStaahOfferId(parseInt(newProperty?.propertyOfferId));
      prperty = newProperty?.property;
    } else {
      prperty = newProperty;
      setStaahOfferId(0);
    }
    const label = prperty?.cityName;
    const value = prperty?.cityId;
    const property_Id = prperty?.staahPropertyId;
    setCityDetails({ label, value, property_Id });
    setStaahPropertyId(prperty?.staahPropertyId);
    setHandleSearchProp(true);

    if (filterBarRef.current) {
      filterBarRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      const firstInput = filterBarRef.current.querySelector(
        "input, select, button",
      );
      if (firstInput) firstInput.focus();
    }
  };

  const handlePropertyBookNow3 = async () => {
    setOpen(false);
    setShowFilterBar(false);
  };

  const CloseBookingEngine = async () => {
    setOpen(true);
    setShowFilterBar(true);
  };

  return (
    <>
      <Header
        onClick={handlePropertyBookNow}
        onClickHotel={handlePropertyBookNow3}
        onCloseBookingEngine={CloseBookingEngine}
      />

      <section ref={filterBarRef} className="position-relative">
        {/* <HeroBannerVideo /> */}

        <section
          className="position-fixed start-0 w-100 bg-white shadow"
          ref={filterBarRef}
        >
          {/* {isOpenFilterBar &&
            typeof window !== "undefined" &&
            createPortal(
              <BookingEngineProvider>
                <FilterBar
                  contentData={contentData}
                  tokenKey={tokenKey}
                  selectedProperty={0}
                  openBookingBar={isOpenFilterBar}
                  onClose={() => {
                    openFilterBar(false);
                    setOpen(false);
                  }}
                />
              </BookingEngineProvider>,
              document.body,
            )} */}

          {showFilterBar &&
            typeof document !== "undefined" &&
            createPortal(
              <BookingEngineProvider>
                <FilterBar
                  selectedProperty={parseInt(cityDetails.property_Id)}
                  cityDetails={cityDetails ?? {}}
                  openBookingBar={showFilterBar}
                  onClose={(isReload) => {
                    // if (window.innerWidth < 768) {
                    setOpen((prev) => !prev);
                    setShowFilterBar((prev) => !prev);
                    setStaahPropertyId(null);
                    // }
                    if (isReload) {
                      window.location.reload();
                    }
                    setHandleSearchProp(false);
                  }}
                  isHandleSearchProp={isHandleSearchProp}
                  staahOfferId={parseInt(staahOfferId)}
                />
              </BookingEngineProvider>,
              document.body,
            )}
        </section>
      </section>

      <HomeOffersTabs
        activeTab={activeTab}
        onTabChange={setActiveTab}
        onOfferBookNow={handlePropertyBookNow}
        onPackageBookNow={handleOfferPackage}
        brandPageColor="#f04e02"
      />
    </>
  );
}
